import {FC, ReactNode} from 'react';

import css from '../styles/BenefitsListItem.module.css';

export interface BenefitsListItemProps {
  title: string;
  icon: ReactNode;
}

const BenefitsListItem: FC<BenefitsListItemProps> = ({title, icon}) => {
  return (
    <div className={css.benefit}>
      <div className={css.icon}>{icon}</div>
      <div className={css.title}>{title}</div>
    </div>
  );
};

export default BenefitsListItem;
